// @flow

import type { SocialObjectType } from '@ta/social.types';
import { RepostedObjectTypeMap, SocialObjectTypeMap } from '@ta/social.types';
import { useInvalidatableQuery } from '@ta/platform.urql';
import RepostStatsQuery from './RepostStatsQuery.gql';

type RepostStats = {|
  isReposted: boolean,
  repostCount: number,
|};

const useUpdatedRepostStats: (
  repostObjectId: string,
  repostType: SocialObjectType,
) => ?RepostStats = (repostObjectId: string, repostType: SocialObjectType) => {
  const isRepostable = repostType in RepostedObjectTypeMap;

  const shouldInvalidate = (repostRefGql: any) =>
    String(repostRefGql.refId) === String(repostObjectId) &&
    repostRefGql.refType === SocialObjectTypeMap[repostType]
      ? 'invalidateAndRefetch'
      : 'validate';
  const [{ data, fetching, error }] = useInvalidatableQuery(
    {
      query: RepostStatsQuery,
      variables: {
        socialObjects: [
          { objectId: String(repostObjectId), objectType: SocialObjectTypeMap[repostType] },
        ],
      },
      executeWhen: isRepostable ? 'afterInvalidation' : 'never',
    },
    {
      createRepost: shouldInvalidate,
    },
  );

  return (
    (!fetching &&
      !error &&
      data &&
      data.socialStatistics &&
      data.socialStatistics.length &&
      data.socialStatistics[0]) ||
    null
  );
};

export default useUpdatedRepostStats;
